import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';

export const ToastContext = React.createContext(null);

export default (props) => {
    const [messages, setMessages] = useState([]);

    const show = (body, bg, title = '', autohide = true, delay = 3000) => {
        title = bg === 'success' ? 'موفق' : bg === 'danger' ? 'خطا' : title;
        setMessages([
            ...messages,
            {
                key: Math.random(),
                title,
                body,
                bg,
                autohide,
                delay
            }
        ]);
    };

    const handleClose = (key) => {
        setMessages([
            ...messages.filter(message => message.key !== key)
        ]);
    };

    return <ToastContext.Provider value={show}>
        <div id="toast-container">
            {
                messages.map(({ key, title, body, bg, autohide, delay }) =>
                    <Toast
                        key={key}
                        onClose={() => handleClose(key)}
                        delay={delay}
                        autohide={autohide}
                        className={`bg-${bg}`}
                        show
                    >
                        <Toast.Header className="justify-content-between">
                            <strong className="me-auto">
                                {title}
                            </strong>
                        </Toast.Header>
                        <Toast.Body className="text-right text-white">
                            {body}
                        </Toast.Body>
                    </Toast>
                )
            }
        </div>
        {
            props.children
        }
    </ToastContext.Provider>;
}
